import { Component } from '@angular/core';
import { Select } from '@ngxs/store';
import { Observable } from 'rxjs';

import { ISchoolYear } from '../../../interfaces/groups/school-year.interface';
import { SchoolYearState } from '../../../store/state/school-year.state';

@Component({
    selector: 'app-events-booking',
    templateUrl: './events-booking.component.html',
    styleUrls: ['./events-booking.component.scss'],
})
export class EventsBookingComponent {
    @Select(SchoolYearState.getCurrentSchoolYear) public schoolYear$: Observable<ISchoolYear>;
}
